// extracted by mini-css-extract-plugin
export var copyableField = "_qp-4";
export var customerBadge = "_qp-0";
export var customerInfoTitle = "_qp-2";
export var details = "_qp-1";
export var dropdownContainer = "_qp-5";
export var dropdownImage = "_qp-6";
export var editAssigneeForm = "_qp-a";
export var editButton = "_qp-3";
export var email = "_qp-7";
export var hidden = "_qp-d";
export var input = "_qp-8";
export var saveButton = "_qp-b";
export var shopifyIcon = "_qp-c";
export var suggestionBadge = "_qp-e";
export var suggestionText = "_qp-f";
export var username = "_qp-9";